import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
import Layout from "@/layout";

export const constantRoutes = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    meta: { allow: false },
    children: [
      {
        path: "/redirect/:path(.*)",
        meta: { allow: false },
        component: () => import("@/views/redirect/index")
      }
    ]
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    meta: { allow: false },
    hidden: true
  },
  {
    path: "/auth-redirect",
    meta: { allow: false },
    component: () => import("@/views/login/auth-redirect"),
    hidden: true
  },
  {
    path: "/404",
    meta: { allow: true },
    component: () => import("@/views/error-page/404"),
    hidden: true
  },
  {
    path: "/401",
    meta: { allow: true },
    component: () => import("@/views/error-page/401"),
    hidden: true
  },
  // 商户管理
  {
    path: "/merchant",
    component: Layout,
    hidden: false,
    redirect: "/merchant/index",
    meta: {
      title: "商户管理",
      icon: "shangcheng",
      allow: false
    },
    children: [
      {
        path: "index",
        component: () => import("@/views/merchant/index"),
        name: "Merchant",
        hidden: false,
        meta: {
          title: "商户管理",
          noCache: true,
          activeMenu: "/merchant/index",
          rank: "1.1",
          allow: false
        }
      },
      {
        path: "cooperationList",
        component: () => import("@/views/merchant/cooperationList2"),
        name: "CooperationList2",
        hidden: false,
        meta: {
          title: "商户合作管理",
          noCache: true,
          isHidden: true,
          allow: false
        }
      },
      {
        path: "cooperation",
        component: () => import("@/views/merchant/cooperationList"),
        name: "Cooperation",
        hidden: false,
        meta: {
          title: "商户合作审核",
          noCache: true,
          activeMenu: "/merchant/cooperation",
          rank: "1.1",
          isHidden: true,
          allow: false
        }
      },
      {
        path: "index/details",
        component: () => import("@/views/merchant/merchantDetails"),
        name: "MerchantDetail",
        hidden: true,
        meta: {
          title: "商户详情",
          noCache: true,
          activeMenu: "/merchant/index",
          rank: "1",
          allow: false
        }
      },
      {
        path: "cooperationList/cooperationEdit",
        component: () => import("@/views/merchant/cooperationEdit"),
        name: "editCooperation",
        hidden: true,
        meta: {
          title: "合作信息",
          activeMenu: "/merchant/cooperationList",
          noCache: true,
          rank: "1",
          allow: false
        }
      }
    ]
  },
  // 中转商户
  // {
  //   path: "/zzMerchant",
  //   component: Layout,
  //   redirect: "/zzMerchant/index",
  //   hidden: false,
  //   meta: {
  //     title: "中转商户管理",
  //     icon: "swap-box-line",
  //     allow: false
  //   },
  //   children: [
  //     {
  //       path: "index",
  //       component: () => import("@/views/zzMerchant/index"),
  //       name: "ZZMerchant",
  //       hidden: false,
  //       meta: {
  //         title: "中转商户管理",
  //         noCache: false,
  //         activeMenu: "/zzMerchant/index",
  //         rank: "1.1",
  //         allow: false
  //       }
  //     },
  //     {
  //       path: "zzCooperationList",
  //       component: () => import("@/views/zzMerchant/cooperationList2"),
  //       name: "zzCooperationList2",
  //       hidden: false,
  //       meta: {
  //         title: "中转商户合作管理",
  //         noCache: true,
  //         activeMenu: "/zzMerchant/zzCooperationList",
  //         allow: false
  //       }
  //     },
  //     {
  //       path: "zzCooperation",
  //       component: () => import("@/views/zzMerchant/cooperationList"),
  //       name: "zzCooperation",
  //       hidden: false,
  //       meta: {
  //         title: "中转商户合作审核",
  //         noCache: true,
  //         activeMenu: "/zzMerchant/zzCooperation",
  //         rank: "1.1",
  //         allow: false
  //       }
  //     },
  //     {
  //       path: "index/details",
  //       component: () => import("@/views/zzMerchant/merchantDetails"),
  //       name: "zzMerchantDetail",
  //       hidden: true,
  //       meta: {
  //         title: "商户详情",
  //         noCache: true,
  //         activeMenu: "/zzMerchant/index",
  //         rank: "1",
  //         allow: false
  //       }
  //     },
  //     {
  //       path: "zzCooperationList/cooperationEdit",
  //       component: () => import("@/views/zzMerchant/cooperationEdit"),
  //       name: "zzEditCooperation",
  //       hidden: true,
  //       meta: {
  //         title: "合作信息",
  //         activeMenu: "/zzMerchant/zzCooperationList",
  //         noCache: true,
  //         rank: "1",
  //         allow: false
  //       }
  //     }
  //   ]
  // },

  // 新业态合作
  {
    path: "/newBusiness",
    component: Layout,
    redirect: "/newBusiness/storeManage",
    hidden: false,
    meta: {
      title: "新业态任务",
      icon: "eject-line",
      allow: false
    },
    children: [
      {
        path: "storeManage",
        component: () => import("@/views/newBusiness/storeManage/index"),
        name: "StoreManage",
        hidden: false,
        meta: { title: "门店管理", noCache: true, allow: false }
      },
      {
        path: "recruiting",
        component: () => import("@/views/newBusiness/recruiting/index"),
        name: "NewBusinessRecruiting",
        hidden: false,
        meta: { title: "招聘管理", noCache: true, allow: false }
      },
      {
        path: "recruiting/detail",
        component: () => import("@/views/newBusiness/recruiting/detail"),
        name: "newBusinessRecruitingDetail",
        hidden: true,
        meta: { title: "招聘详情", noCache: true, activeMenu: "/newBusiness/recruiting", allow: false }
      },
      {
        path: "taskManage",
        component: () => import("@/views/newBusiness/taskManage/index.vue"),
        name: "TaskManage",
        hidden: false,
        meta: { title: "任务管理", noCache: true, rank: "1.1", allow: false }
      },
      {
        path: "taskManage/manageDetail",
        component: () => import("@/views/newBusiness/taskManage/manageDetail.vue"),
        name: "taskManageDetail",
        hidden: true,
        meta: {
          title: "任务详情",
          noCache: true,
          rank: "1.1",
          allow: false,
          activeMenu: "/newBusiness/taskManage"
        }
      },
      {
        path: "taskManage/detail",
        component: () => import("@/views/newBusiness/taskManage/lookDetail"),
        name: "taskManageLookDetail",
        hidden: true,
        meta: { title: "任务详情", icon: "", activeMenu: "/newBusiness/taskManage", noCache: true, allow: false }
      },
      {
        path: "taskManage/attendanceInfo",
        component: () => import("@/views/newBusiness/taskManage/attendanceInfo"),
        name: "attendanceInfo",
        hidden: true,
        meta: { title: "考勤管理", icon: "", activeMenu: "/newBusiness/taskManage", noCache: true, allow: false }
      }
    ]
  },
  // 派单
  {
    path: "/sendOrders",
    component: Layout,
    redirect: "/sendOrders/index",
    hidden: false,
    meta: {
      title: "派单任务",
      icon: "wallet-line",
      allow: false
    },
    children: [
      {
        path: "index",
        component: () => import("@/views/sendOrders/index"),
        name: "sendOrdersIndex",
        hidden: false,
        meta: { title: "派单任务", rank: "1.1", allow: false }
      },
      {
        path: "index/taskDetails",
        component: () => import("@/views/sendOrders/component/taskDetails"),
        name: "sendOrdersTaskDetails",
        hidden: true,
        meta: { title: "任务详情", rank: "1", allow: false, activeMenu: "/sendOrders/index" }
      },
      {
        path: "index/settlementDetails",
        component: () => import("@/views/sendOrders/component/settlementDetails"),
        name: "sendOrdersSettlementDetails",
        hidden: true,
        meta: { title: "结算详情", rank: "1", allow: false, activeMenu: "/sendOrders/index" }
      },
      {
        path: "checkDetail",
        component: () => import("@/views/sendOrders/checkDetail"),
        name: "SendOrdersCheckDetail",
        hidden: false,
        meta: { title: "交付单详情", rank: "1.1", allow: false }
      }
    ]
  },
  // 常规任务
  {
    path: "/task",
    component: Layout,
    hidden: false,
    redirect: "/task/index",
    meta: {
      title: "常规任务",
      icon: "coupon-line",
      allow: false
    },
    children: [
      {
        path: "index",
        hidden: false,
        component: () => import("@/views/task/index"),
        name: "TaskIndex",
        meta: { title: "常规任务", noCache: true, rank: "1.1", allow: false }
      },
      {
        path: "index/details",
        component: () => import("@/views/task/details"),
        name: "details",
        hidden: true,
        meta: { title: "任务详情", noCache: true, activeMenu: "/task/index", rank: "1", allow: false }
      },
      {
        path: "checkDetail",
        component: () => import("@/views/task/checkDetail"),
        name: "TaskCheckDetail",
        hidden: false,
        meta: { title: "交付单详情", rank: "1.1", allow: false }
      }
    ]
  },
  // 人员管理
  {
    path: "/user",
    component: Layout,
    hidden: false,
    redirect: "/user/index",
    meta: {
      title: "人员管理",
      icon: "wode-weixuanzhong",
      allow: false
    },
    children: [
      {
        path: "index",
        hidden: false,
        component: () => import("@/views/user/index"),
        name: "User",
        meta: { title: "人员列表", noCache: false, rank: "1.1", isHidden: true, allow: false }
      },
      {
        path: "index/details",
        component: () => import("@/views/user/userDetails"),
        name: "userDetail",
        hidden: true,
        meta: { title: "人员详情", rank: "1", allow: false }
      },
      // {
      //   path: "contractDetails",
      //   hidden: false,
      //   component: () => import("@/views/contractWork/contractDetails"),
      //   name: "ContractDetails",
      //   meta: { title: "签约明细", noCache: true, rank: "1.1", allow: false }
      // },
      {
        path: "index/taskList",
        component: () => import("@/views/user/taskList"),
        name: "taskList",
        hidden: true,
        meta: { title: "任务列表", noCache: true, allow: false }
      },
      {
        path: "personPost",
        component: () => import("@/views/user/personPost"),
        name: "PersonPost",
        hidden: false,
        meta: { title: "人岗合同", noCache: false, allow: false }
      },
      {
        path: "PersonCompany",
        component: () => import("@/views/user/personCompany"),
        name: "PersonCompany",
        hidden: false,
        meta: { title: "人企合同", noCache: false, allow: false }
      }
    ]
  },
  // 订单管理
  {
    path: "/order",
    component: Layout,
    redirect: "/order/batchOrder",
    hidden: false,
    meta: {
      title: "订单管理",
      icon: "clapperboard-line",
      allow: false
    },
    children: [
      {
        path: "batchOrder",
        hidden: false,
        component: () => import("@/views/order/batchOrder"),
        name: "BatchOrder",
        meta: { title: "批次订单", noCache: true, rank: "1.1", allow: false }
      },
      {
        path: "oneOrder",
        hidden: false,
        component: () => import("@/views/order/oneOrder"),
        name: "OneOrder",
        meta: { title: "单笔订单", noCache: true, rank: "1.1", allow: false }
      }
    ]
  },
  // //交付管理
  // {
  //   path: "/deliveryManage",
  //   component: Layout,
  //   redirect: "/deliveryManage/detail",
  //   hidden: false,
  //   meta: {
  //     title: "交付管理",
  //     icon: "undertake-delivery",
  //     allow: false
  //   },
  //   children: [
  //     {
  //       path: "detail",
  //       component: () => import("@/views/deliveryManage/detail"),
  //       name: "DeliveryManageDetail",
  //       hidden: false,
  //       meta: { title: "交付单详情", rank: "1.1", allow: false }
  //     }
  //   ]
  // },
  // 账户管理
  {
    path: "/account",
    component: Layout,
    hidden: false,
    redirect: "/account/moneyAccount",
    meta: {
      title: "账户管理",
      icon: "chat-smile-2-line",
      isHidden: true,
      allow: false
    },
    children: [
      {
        path: "moneyAccount",
        hidden: false,
        component: () => import("@/views/account/moneyAccount"),
        name: "MoneyAccount",
        meta: { title: "资金账户", rank: "1", isHidden: true, allow: false }
      },
      {
        path: "recordAccount",
        hidden: false,
        component: () => import("@/views/account/recordAccount"),
        name: "RecordAccount",
        meta: { title: "服务费账户", rank: "1.1", isHidden: true, allow: false }
      },
      {
        path: "recordAccount/billList",
        component: () => import("@/views/account/billList"),
        name: "billList",
        hidden: true,
        meta: { title: "流水查看", noCache: true, activeMenu: "/account/recordAccount", allow: false }
      },
      {
        path: "taxFreeAccount",
        component: () => import("@/views/account/taxFreeAccount"),
        name: "TaxFreeAccount",
        hidden: false,
        meta: { title: "税费账户", noCache: true, rank: "1.1", allow: false }
      },
      {
        path: "taxFreeAccount/taxFreeWaterfall",
        component: () => import("@/views/account/taxFreeWaterfall"),
        name: "TaxFreeWaterfall",
        hidden: true,
        meta: { title: "税费账户流水", noCache: true, rank: "1.1", allow: false, activeMenu: "/account/taxFreeAccount" }
      },
      {
        path: "recordAccountNew",
        hidden: false,
        component: () => import("@/views/account/recordAccountNew"),
        name: "RecordAccountNew",
        meta: { title: "客户账户", rank: "1.1", isHidden: true, allow: false }
      },
      {
        path: "recordAccountNew/billListNew",
        component: () => import("@/views/account/billListNew"),
        name: "billListNew",
        hidden: true,
        meta: { title: "流水统计", noCache: true, activeMenu: "/account/recordAccountNew", allow: false }
      }
    ]
  },
  // 自动分账
  {
    path: "/autoManage",
    component: Layout,
    hidden: false,
    redirect: "/autoManage/autoAccount",
    meta: {
      title: "自动分账",
      icon: "coins-line",
      allow: false
    },
    children: [
      {
        path: "splitBill",
        hidden: false,
        component: () => import("@/views/autoManage/splitBill"),
        name: "SplitBill",
        meta: {
          title: "分账订单",
          noCache: true,
          rank: "1.1",
          allow: false
        }
      },
      {
        path: "autoAccount",
        hidden: false,
        component: () => import("@/views/autoManage/autoAccount"),
        name: "AutoAccount",
        meta: {
          title: "分账账户",
          noCache: true,
          rank: "1.1",
          allow: false
        }
      },
      {
        path: "splitPlan",
        hidden: false,
        component: () => import("@/views/autoManage/splitPlan"),
        name: "SplitPlan",
        meta: {
          title: "分账策略",
          noCache: true,
          rank: "1.1",
          allow: false
        }
      },
      {
        path: "autoAccount/autoBillList",
        component: () => import("@/views/autoManage/autoBillList"),
        name: "AutoBillList",
        hidden: true,
        meta: {
          title: "自动分账流水",
          rank: "1.1",
          noCache: true,
          activeMenu: "/autoManage/autoAccount",
          allow: false
        }
      }
    ]
  },
  // 资金业务
  {
    path: "/capital",
    component: Layout,
    hidden: false,
    redirect: "/capital/rechargeCapital",
    meta: {
      title: "资金业务",
      icon: "money-cny-circle-line",
      isHidden: true,
      allow: false
    },
    children: [
      {
        path: "rechargeCapital",
        hidden: false,
        component: () => import("@/views/capital/rechargeCapital"),
        name: "RechargeCapital",
        meta: { title: "充值单", noCache: true, rank: "1.1", isHidden: true, allow: false }
      },
      {
        path: "refundCapital",
        hidden: false,
        component: () => import("@/views/capital/refundCapital"),
        name: "RefundCapital",
        meta: { title: "退款单", noCache: true, rank: "1.1", isHidden: true, allow: false }
      },
      {
        path: "withDrawalCapital",
        hidden: false,
        component: () => import("@/views/capital/withDrawalCapital"),
        name: "WithDrawalCapital",
        meta: { title: "提现单", noCache: true, rank: "1.1", isHidden: true, allow: false }
      },
      {
        path: "ticketCapital",
        hidden: false,
        component: () => import("@/views/capital/ticketCapital"),
        name: "TicketCapital",
        meta: { title: "退票单", noCache: true, rank: "1.1", isHidden: true, allow: false }
      },
      {
        path: "transferOrder",
        hidden: false,
        component: () => import("@/views/capital/transferOrder"),
        name: "TransferOrder",
        meta: { title: "划拨单", noCache: true, rank: "1.1", isHidden: true, allow: false }
      },
      {
        path: "taxRefundForm",
        hidden: false,
        component: () => import("@/views/capital/taxRefundForm"),
        name: "TaxRefundForm",
        meta: { title: "退税单", noCache: true, rank: "1.1", isHidden: true, allow: false }
      }
    ]
  },
  // 数据统计
  {
    path: "/statistics",
    component: Layout,
    hidden: false,
    redirect: "/statistics/busSettleForm",
    meta: {
      title: "数据统计",
      icon: "funds-box-line",
      allow: false
    },
    children: [
      {
        path: "merchants-statistics-monthly",
        hidden: false,
        component: () => import("@/views/statistics/merchantsStatisticsMonthly/index"),
        name: "MerchantsStatisticsMonthly",
        meta: { title: "商户发放统计", noCache: true, rank: "1.4", allow: false }
      },
      // {
      //   path: "remittance-distribution",
      //   hidden: false,
      //   component: () => import("@/views/statistics/remittanceDistribution"),
      //   name: "RemittanceDistribution",
      //   meta: { title: "平台发放分布", noCache: true, rank: "1.3", allow: false }
      // },
      // {
      //   path: "remittance-trend",
      //   component: () => import("@/views/statistics/merchantsStatisticsMonthly/remittanceTrend"),
      //   name: "RemittanceTrend",
      //   hidden: false,
      //   meta: { title: "商户账户统计趋势", noCache: true, rank: "1.4.1", allow: false }
      // },
      {
        path: "merchant-staff-pay",
        component: () => import("@/views/statistics/merchantStaffPay"),
        name: "MerchantStaffPay",
        hidden: false,
        meta: { title: "月度人员发放统计", noCache: true, rank: "1.5", allow: false }
      },
      {
        path: "invoices",
        hidden: false,
        component: () => import("@/views/statistics/invoices"),
        name: "Invoices",
        meta: { title: "商户开票账户", noCache: true, rank: "1.9", allow: false }
      },
      {
        path: "busSettleForm",
        hidden: false,
        component: () => import("@/views/statistics/busSettleForm"),
        name: "BusSettleForm",
        meta: { title: "业务结算单", noCache: true, rank: "1.5", allow: false }
      },
      {
        path: "taxCertificateForm",
        hidden: false,
        component: () => import("@/views/statistics/taxCertificateForm"),
        name: "TaxCertificateForm",
        meta: { title: "商户完税证明", noCache: true, rank: "1.6", allow: false }
      }
    ]
  },
  // 开票管理
  {
    path: "/invoice",
    component: Layout,
    hidden: false,
    redirect: "/invoice/invoiceManage",
    meta: {
      title: "开票管理",
      icon: "wallet-2-line",
      allow: false
    },
    children: [
      {
        path: "invoiceManage",
        hidden: false,
        component: () => import("@/views/invoice/invoiceManage"),
        name: "invoiceManage",
        meta: { title: "开票管理", noCache: true, allow: false }
      },
      {
        path: "invoiceManage/invoiceDetails",
        component: () => import("@/views/invoice/invoiceDetails"),
        name: "invoiceDetails",
        hidden: true,
        meta: {
          title: "详情",
          activeMenu: "/invoice/invoiceManage",
          noCache: true,
          allow: false
        }
      },
      {
        path: "invoiceMaintain",
        hidden: false,
        component: () => import("@/views/invoice/invoiceMaintain"),
        name: "InvoiceMaintain",
        meta: { title: "当月票量维护", noCache: true, allow: false }
      },
      {
        path: "invoiceManage/applyInvoice",
        component: () => import("@/views/invoice/applyInvoice"),
        name: "ApplyInvoice",
        hidden: true,
        meta: { title: "申请开票", noCache: true, rank: "1.1", allow: false }
      },
      {
        path: "invoiceManage/selectInvoice",
        component: () => import("@/views/invoice/selectInvoice"),
        name: "SelectInvoice",
        hidden: true,
        meta: {
          title: "选择订单",
          activeMenu: "/invoice/invoiceManage",
          noCache: true,
          allow: false
        }
      }
    ]
  },
  //中转服务商-开票管理
  {
    path: "/transferInvoice",
    component: Layout,
    hidden: false,
    redirect: "/transferInvoice/toMerchant",
    meta: {
      title: "开票管理",
      icon: "wallet-2-line",
      allow: false
    },
    children: [
      {
        path: "toMerchant",
        hidden: false,
        component: () => import("@/transferServiceView/transferInvoice/toMerchant/index"),
        name: "ToMerchant",
        meta: { title: "给商户开票", noCache: true, allow: false }
      },
      {
        path: "toTaxSource",
        hidden: false,
        component: () => import("@/transferServiceView/transferInvoice/toTaxSource/index"),
        name: "ToTaxSource",
        meta: {
          title: "向服务商申请开票",
          icon: "",
          activeMenu: "/transferInvoice/toTaxSource",
          noCache: true,
          allow: false
        }
      },
      {
        path: "toTaxSource/selectInvoice",
        component: () => import("@/transferServiceView/transferInvoice/toTaxSource/selectInvoice"),
        name: "SelectInvoice",
        hidden: true,
        meta: {
          title: "向服务商申请开票",
          icon: "",
          activeMenu: "/transferInvoice/toTaxSource",
          noCache: true,
          allow: false
        }
      },
      {
        path: "toTaxSource/invoicingEdit",
        component: () => import("@/transferServiceView/transferInvoice/toTaxSource/invoicingEdit"),
        name: "invoicingEdit",
        hidden: true,
        meta: {
          title: "向服务商申请开票",
          icon: "",
          activeMenu: "/transferInvoice/toTaxSource",
          noCache: true,
          allow: false
        }
      },
      {
        path: "toTaxSource/details",
        component: () => import("@/transferServiceView/transferInvoice/toTaxSource/details"),
        name: "invoicingDetails",
        hidden: true,
        meta: {
          title: "向服务商申请开票",
          icon: "",
          activeMenu: "/transferInvoice/toTaxSource",
          noCache: true,
          allow: false
        }
      }
    ]
  },
  // 普通服务商管理
  {
    path: "/taxSources",
    component: Layout,
    hidden: false,
    redirect: "/taxSources/taxSetting",
    meta: {
      title: "普通服务商管理",
      icon: "hand-heart-line",
      isHidden: true,
      allow: false
    },
    children: [
      {
        path: "taxSetting",
        hidden: false,
        component: () => import("@/views/taxSources/taxSetting"),
        name: "taxSetting",
        meta: { title: "服务商信息", noCache: true, isHidden: true, allow: false }
      },
      {
        path: "invoiceSubject",
        hidden: false,
        component: () => import("@/views/taxSources/invoiceSubject"),
        name: "InvoiceSubject",
        meta: { title: "开票类目", noCache: true, isHidden: true, allow: false }
      }
    ]
  },
  //中转服务商
  {
    path: "/transitTax",
    component: Layout,
    redirect: "/transitTax/index",
    hidden: false,
    meta: {
      title: "中转服务商管理",
      icon: "swap-box-line",
      allow: false
    },
    children: [
      {
        path: "index",
        component: () => import("@/views/transitTax/index"),
        name: "TransitTaxManage",
        hidden: false,
        meta: {
          title: "中转服务商管理",
          noCache: false,
          activeMenu: "/transitTax/index",
          rank: "1.1",
          allow: false
        }
      }
    ]
  },
  // 下载中心
  {
    path: "/system",
    component: Layout,
    redirect: "/system/loginUser",
    hidden: false,
    meta: {
      title: "系统管理",
      icon: "shezhi",
      allow: false
    },
    children: [
      {
        path: "loginUser",
        hidden: false,
        component: () => import("@/views/taxSources/loginUser"),
        name: "LoginUser",
        meta: { title: "用户管理", noCache: true, isHidden: true, allow: false }
      },
      {
        path: "loginLog",
        component: () => import("@/views/system/loginLog"),
        name: "loginLog",
        hidden: false,
        meta: { title: "操作日志", noCache: true, rank: "1.1", allow: false }
      },
      {
        path: "downloadCenter",
        component: () => import("@/views/download/downloadCenter"),
        name: "DownloadCenter",
        hidden: false,
        meta: { title: "下载中心", noCache: true, rank: "1.1", allow: false }
      }
    ]
  },

  {
    path: "/goIndex",
    hidden: true,
    meta: { returnFirst: true, allow: false }
  },
  {
    path: "/",
    redirect: "/goIndex",
    hidden: true,
    meta: { allow: false }
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
    meta: { allow: false }
  }
];

if (process.env.NODE_ENV !== "production") {
  const index = constantRoutes.findIndex(item => item.path === "/401");
  constantRoutes.splice(index + 1, 0, {
    path: "/template",
    component: Layout,
    redirect: "/template/index",
    hidden: false,
    meta: {
      title: "模版目录",
      icon: "eject-line",
      allow: true
    },
    children: [
      {
        path: "index",
        component: () => import("@/template/index"),
        name: "Index",
        hidden: false,
        meta: {
          title: "模版列表",
          noCache: false,
          allow: true
        }
      },
      {
        path: "form",
        component: () => import("@/template/form"),
        name: "Form",
        hidden: false,
        meta: {
          title: "模版表单页",
          noCache: false,
          allow: true
        }
      },
      {
        path: "stepForm",
        component: () => import("@/template/stepForm"),
        name: "StepForm",
        hidden: false,
        meta: {
          title: "分段模版表单页",
          noCache: false,
          allow: true
        }
      }
    ]
  });
}

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

const initRouter = () => {
  const router = constantRoutes.map(item => {
    const r = { hidden: item.hidden, meta: JSON.parse(JSON.stringify(item.meta)) };
    if (item.children) {
      r.children = item.children.map(i => {
        return { hidden: i.hidden, meta: JSON.parse(JSON.stringify(i.meta)) };
      });
    }
    return r;
  });
  return router;
};

export const constant = initRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

export default router;
